const TOPICS = {
    meTabSelected: 'ME/TabSelected'
};

export default TOPICS;